module.exports = __webpack_public_path__ + "img/search_policy.5ea4eb71.png";